import t from "@constants/localization";

const DELIVERY_PATH = "screens/MyDeliveries/DeliveryReturn/DeliveryCard";
const PATH = "screens/MyDeliveries/DeliveryReturn/OverView";

export const getItemsNotReturnedText = (returnDetails = {}) => {
  if (returnDetails.cratesNotReturned && returnDetails.itemsNotReturned) {
    return `${returnDetails.cratesNotReturned} ${t(`${PATH}/crate`)}, ${returnDetails.itemsNotReturned} ${t(`${PATH}/item`)} ${t(`${PATH}/notReturned`)}`;
  } else if (returnDetails.cratesNotReturned) {
    return `${returnDetails.cratesNotReturned} ${t(`${PATH}/crate`)} ${t(`${PATH}/notReturned`)}`;
  } else if (returnDetails.itemsNotReturned) {
    return `${returnDetails.itemsNotReturned} ${t(`${PATH}/item`)} ${t(`${PATH}/notReturned`)}`;
  }
  return `${t(`${PATH}/notReturned`)}`;
};

export const getUnableToDeliverText = (unableToDeliver = {}) => {
  let txt = "";
  if (
    unableToDeliver.noOfCrates &&
    unableToDeliver.noOfShipments &&
    unableToDeliver.noOfOpenItems
  ) {
    txt = `${unableToDeliver.noOfCrates} ${t(`${DELIVERY_PATH}/crate`)}, ${unableToDeliver.noOfShipments} ${t(`${DELIVERY_PATH}/packets`)}, ${unableToDeliver.noOfOpenItems} ${t(`${DELIVERY_PATH}/items`)}`;
  } else if (unableToDeliver.noOfCrates && unableToDeliver.noOfShipments) {
    txt = `${unableToDeliver.noOfCrates} ${t(`${DELIVERY_PATH}/crate`)}, ${unableToDeliver.noOfShipments} ${t(`${DELIVERY_PATH}/packets`)}`;
  } else if (unableToDeliver.noOfCrates && unableToDeliver.noOfOpenItems) {
    txt = `${unableToDeliver.noOfCrates} ${t(`${DELIVERY_PATH}/crate`)}, ${unableToDeliver.noOfOpenItems} ${t(`${DELIVERY_PATH}/items`)}`;
  } else if (unableToDeliver.noOfShipments && unableToDeliver.noOfOpenItems) {
    txt = `${unableToDeliver.noOfShipments} ${t(`${DELIVERY_PATH}/packets`)}, ${unableToDeliver.noOfOpenItems} ${t(`${DELIVERY_PATH}/items`)}`;
  } else if (unableToDeliver.noOfCrates) {
    txt = `${unableToDeliver.noOfCrates} ${t(`${DELIVERY_PATH}/crate`)}`;
  } else if (unableToDeliver.noOfShipments) {
    txt = `${unableToDeliver.noOfShipments} ${t(`${DELIVERY_PATH}/packets`)}`;
  } else if (unableToDeliver.noOfOpenItems) {
    txt = `${unableToDeliver.noOfOpenItems} ${t(`${DELIVERY_PATH}/items`)}`;
  }
  if (unableToDeliver.noOfCdcBags) {
    txt += `${txt.length ? ", " : ""}${unableToDeliver.noOfCdcBags} ${t(`${DELIVERY_PATH}/bags`) || "bags"}`;
  }
  if (txt.length) txt += ` ${t(`${DELIVERY_PATH}/notDelivered`)}`;
  return txt.length ? txt : `${t(`${DELIVERY_PATH}/notDelivered`)}`;
};

export const getCrateListFromCrateIds = (list) => {
  return list && Array.isArray(list)
    ? list.map((id) => {
        return `${t(`${DELIVERY_PATH}/crate`)} - ${id}`;
      })
    : [];
};
